// helpers
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { ERROR_EVENTS } from 'shared/helpers/analytics/constants/errors';
import { PAGE_TYPE, EVENTS } from 'shared/helpers/DTM';
import { TEXT } from './constants';

const CHANNEL = 'NDS';

export const onPageLoad = () => {
  const data: { [key: string]: string | boolean } = {};
  data.pagetype = PAGE_TYPE.ERROR;
  data.pagename = `${CHANNEL}:${PAGE_TYPE.ERROR}`;
  data.channel = CHANNEL;
  data.eventName = EVENTS.ERROR;
  data.errorMSG = '404';

  // DTM.onPageLoad(data);
  NFA.track({
    data: {
      errorCode: '404',
      errorMessage: TEXT.BROKEN_MSG,
    },
    type: TRACK_TYPE.PAGELOAD,
    event: ERROR_EVENTS.ERROR_PAGE_LOADS,
    dtmData: data,
  });
};
